/**
 * StingBase
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { HttpHeaders }                                       from '@angular/common/http';

import { Observable }                                        from 'rxjs';

import { GetMunicipalitiesFilterParameter } from '../model/models';
import { InlineObject } from '../model/models';
import { InlineObject1 } from '../model/models';
import { MunicipalityResource } from '../model/models';


import { Configuration }                                     from '../configuration';



export interface MunicipalityServiceInterface {
    defaultHeaders: HttpHeaders;
    configuration: Configuration;

    /**
     * List of municipalities
     * 
     * @param perPage 
     * @param page 
     * @param include Include relationships. Separate multiple values with comma. Allowed: &#x60;district&#x60;
     * @param filter 
     */
    getMunicipalities(perPage?: number, page?: number, include?: string, filter?: GetMunicipalitiesFilterParameter, extraHttpRequestParams?: any): Observable<Array<MunicipalityResource>>;

}
